let BUSBUD_ENV: string = "production";

export const setBusbudEnv = (env: string): void => {
  BUSBUD_ENV = env;
};

// Utility to access runtime BUSBUD_ENV value across both server and client
export const getBusbudEnv = (): string => {
  return BUSBUD_ENV;
};
